import React, { useState } from 'react';

const Menu = () => {
  const [activeCategory, setActiveCategory] = useState('all');

  const categories = [
    { id: 'all', name: 'All Menu', icon: '🍽️' },
    { id: 'appetizers', name: 'Appetizers', icon: '🥗' },
    { id: 'main', name: 'Main Course', icon: '🍖' },
    { id: 'pasta', name: 'Pasta', icon: '🍝' },
    { id: 'desserts', name: 'Desserts', icon: '🍰' },
    { id: 'drinks', name: 'Drinks', icon: '🍹' },
  ];

  const menuItems = [
    {
      id: 1,
      category: 'appetizers',
      name: 'Caesar Salad',
      description: 'Fresh romaine, parmesan, croutons with signature dressing',
      price: 'Rp 65.000',
      popular: true,
      emoji: '🥗'
    },
    {
      id: 2,
      category: 'appetizers',
      name: 'Bruschetta',
      description: 'Toasted bread with tomato, basil, and olive oil',
      price: 'Rp 55.000',
      popular: false,
      emoji: '🍞'
    },
    {
      id: 3,
      category: 'main',
      name: 'Grilled Salmon',
      description: 'Fresh Atlantic salmon with herbs and lemon butter',
      price: 'Rp 185.000',
      popular: true,
      emoji: '🐟'
    },
    {
      id: 4,
      category: 'main',
      name: 'Beef Tenderloin',
      description: 'Premium beef with black pepper sauce and vegetables',
      price: 'Rp 225.000',
      popular: true,
      emoji: '🥩'
    },
    {
      id: 5,
      category: 'pasta',
      name: 'Spaghetti Carbonara',
      description: 'Creamy carbonara with bacon and parmesan',
      price: 'Rp 95.000',
      popular: true,
      emoji: '🍝'
    },
    {
      id: 6,
      category: 'pasta',
      name: 'Penne Arrabiata',
      description: 'Spicy tomato sauce with garlic and chili',
      price: 'Rp 85.000',
      popular: false,
      emoji: '🍝'
    },
    {
      id: 7,
      category: 'desserts',
      name: 'Tiramisu',
      description: 'Classic Italian dessert with coffee and mascarpone',
      price: 'Rp 65.000',
      popular: true,
      emoji: '🍰'
    },
    {
      id: 8,
      category: 'desserts',
      name: 'Chocolate Lava Cake',
      description: 'Warm chocolate cake with vanilla ice cream',
      price: 'Rp 75.000',
      popular: false,
      emoji: '🍫'
    },
    {
      id: 9,
      category: 'drinks',
      name: 'Fresh Orange Juice',
      description: 'Freshly squeezed orange juice',
      price: 'Rp 35.000',
      popular: false,
      emoji: '🍊'
    },
    {
      id: 10,
      category: 'drinks',
      name: 'Iced Cappuccino',
      description: 'Cold coffee with milk foam',
      price: 'Rp 45.000',
      popular: true,
      emoji: '☕'
    },
  ];

  const filteredItems = activeCategory === 'all' 
    ? menuItems 
    : menuItems.filter(item => item.category === activeCategory);

  return (
    <section id="menu" style={styles.section}>
      <div style={styles.container}>
        <div style={styles.header}>
          <span style={styles.label}>OUR MENU</span>
          <h2 style={styles.heading}>Discover Our Delicious Menu</h2>
          <p style={styles.subheading}>
            Explore our carefully curated selection of culinary masterpieces
          </p>
        </div>

        <div style={styles.categories}>
          {categories.map(category => (
            <button
              key={category.id}
              style={{
                ...styles.categoryBtn,
                ...(activeCategory === category.id ? styles.categoryBtnActive : {})
              }}
              onClick={() => setActiveCategory(category.id)}
            >
              <span style={styles.categoryIcon}>{category.icon}</span>
              {category.name}
            </button>
          ))}
        </div>

        <div style={styles.menuGrid}>
          {filteredItems.map(item => (
            <div key={item.id} style={styles.menuCard}>
              {item.popular && (
                <span style={styles.popularBadge}>⭐ Popular</span>
              )}
              <div style={styles.menuEmoji}>{item.emoji}</div>
              <div style={styles.menuContent}>
                <h3 style={styles.menuName}>{item.name}</h3>
                <p style={styles.menuDesc}>{item.description}</p>
                <div style={styles.menuFooter}>
                  <span style={styles.menuPrice}>{item.price}</span>
                  <button style={styles.addButton}>
                    <span style={styles.addIcon}>+</span>
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div style={styles.cta}>
          <button style={styles.viewAllButton}>View Full Menu</button>
        </div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: '6rem 2rem',
    backgroundColor: 'var(--cream)',
  },
  container: {
    maxWidth: '1400px',
    margin: '0 auto',
  },
  header: {
    textAlign: 'center',
    marginBottom: '3rem',
  },
  label: {
    color: 'var(--maroon)',
    fontSize: '0.9rem',
    fontWeight: '700',
    letterSpacing: '2px',
    marginBottom: '1rem',
    display: 'block',
  },
  heading: {
    fontSize: '3rem',
    fontWeight: '800',
    color: 'var(--dark)',
    marginBottom: '1rem',
    letterSpacing: '-1px',
  },
  subheading: {
    fontSize: '1.2rem',
    color: '#666',
    maxWidth: '600px',
    margin: '0 auto',
  },
  categories: {
    display: 'flex',
    gap: '1rem',
    justifyContent: 'center',
    flexWrap: 'wrap',
    marginBottom: '3rem',
  },
  categoryBtn: {
    padding: '0.9rem 1.8rem',
    border: '2px solid #ddd',
    backgroundColor: 'var(--white)',
    borderRadius: '50px',
    cursor: 'pointer',
    fontWeight: '600',
    fontSize: '0.95rem',
    transition: 'all 0.3s ease',
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    color: 'var(--dark)',
  },
  categoryBtnActive: {
    backgroundColor: 'var(--maroon)',
    color: 'var(--white)',
    borderColor: 'var(--maroon)',
    transform: 'translateY(-2px)',
    boxShadow: '0 5px 15px rgba(139, 46, 59, 0.3)',
  },
  categoryIcon: {
    fontSize: '1.2rem',
  },
  menuGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(320px, 1fr))',
    gap: '2rem',
    marginBottom: '3rem',
  },
  menuCard: {
    backgroundColor: 'var(--white)',
    borderRadius: '25px',
    padding: '2rem',
    transition: 'all 0.3s ease',
    cursor: 'pointer',
    position: 'relative',
    boxShadow: '0 5px 20px rgba(0,0,0,0.05)',
  },
  popularBadge: {
    position: 'absolute',
    top: '1.5rem',
    right: '1.5rem',
    backgroundColor: 'var(--maroon)',
    color: 'var(--white)',
    padding: '0.4rem 1rem',
    borderRadius: '20px',
    fontSize: '0.8rem',
    fontWeight: '600',
  },
  menuEmoji: {
    fontSize: '4rem',
    marginBottom: '1rem',
  },
  menuContent: {
    display: 'flex',
    flexDirection: 'column',
  },
  menuName: {
    fontSize: '1.5rem',
    fontWeight: '700',
    color: 'var(--dark)',
    marginBottom: '0.8rem',
  },
  menuDesc: {
    fontSize: '0.95rem',
    color: '#666',
    lineHeight: '1.6',
    marginBottom: '1.5rem',
    minHeight: '48px',
  },
  menuFooter: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  menuPrice: {
    fontSize: '1.5rem',
    fontWeight: '800',
    color: 'var(--maroon)',
  },
  addButton: {
    width: '45px',
    height: '45px',
    borderRadius: '50%',
    backgroundColor: 'var(--maroon)',
    color: 'var(--white)',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '1.5rem',
    fontWeight: '700',
    transition: 'all 0.3s ease',
    boxShadow: '0 5px 15px rgba(139, 46, 59, 0.3)',
  },
  addIcon: {
    lineHeight: '1',
  },
  cta: {
    textAlign: 'center',
  },
  viewAllButton: {
    backgroundColor: 'var(--maroon)',
    color: 'var(--white)',
    padding: '1.2rem 3rem',
    fontSize: '1.1rem',
    border: 'none',
    borderRadius: '50px',
    cursor: 'pointer',
    fontWeight: '700',
    transition: 'all 0.3s ease',
    boxShadow: '0 10px 30px rgba(139, 46, 59, 0.3)',
  },
};

export default Menu;